import { useQuery } from "@tanstack/react-query";
import { fetchAdminStats } from "../api/admin";

export function useAdminOverview(range: number) {
  return useQuery({
    queryKey: ["admin", "stats", range],
    queryFn: () => fetchAdminStats(range),
  });
}
